import React from 'react';
import './PrayerSectionS2.css';

import shape from '../../images/project/shapebg-3.svg'
import lineGreen from '../../images/service/liine-green.svg'

const PrayerSectionS2 = (props) => {
    const prayers = [
        { name: 'Fajr', time: '5:30 AM', iqamah: '6:00 AM', icon: 'flaticon-mosque' },
        { name: 'Dhuhr', time: '1:00 PM', iqamah: '1:30 PM', icon: 'flaticon-mosque' },
        { name: 'Asr', time: '4:30 PM', iqamah: '5:00 PM', icon: 'flaticon-mosque' },
        { name: 'Maghrib', time: '7:15 PM', iqamah: '7:20 PM', icon: 'flaticon-mosque' },
        { name: 'Isha', time: '8:30 PM', iqamah: '9:00 PM', icon: 'flaticon-mosque' },
    ];

    return (
        <section className={"prayer-section-s2 " + props.hclass}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-12">
                        <div className="section-title text-center">
                            <span style={{color: '#FFFFFF'}}>Prayer Timings</span>
                            <h2><span style={{position: 'relative', color: '#2A896F'}}>Jummah<img src={lineGreen} alt="" style={{position: 'absolute', left: 0, bottom: '-10px', width: '100%'}} /></span>: <span style={{fontSize: '0.7em', color: '#FFFFFF'}}>1:00 PM | 2:00 PM</span></h2>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                {/* Desktop view - cards */}
                <div className="service-wrap desktop-prayers">
                    {prayers.map((prayer, index) => (
                        <div className="item" key={index} style={{pointerEvents: 'none'}}>
                            <div className="visible-content">
                                <div className="icon">
                                    <i className={prayer.icon}></i>
                                </div>
                                <div className="text" style={{textAlign: 'center'}}>
                                    <h2>{prayer.name}</h2>
                                    <span style={{fontSize: '18px'}}>{prayer.time}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {/* Mobile view - table */}
                <div className="mobile-prayers">
                    <div className="prayer-table-card">
                        <table className="prayer-table">
                            <tbody>
                                {prayers.map((prayer, index) => (
                                    <tr key={index}>
                                        <td className="prayer-name">{prayer.name}</td>
                                        <td className="prayer-time">{prayer.time}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className="bg-shape">
                <img src={shape} alt="" />
            </div>
        </section>
    );
};

export default PrayerSectionS2;
